export { default } from './Post';